import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeoPoint, HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { DeliverySlot, OCC_ENDPOINTS, OccDeliveryResponse } from '@delivery/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccDeliverySlotsService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadByGeoPoint(geoPoint: GeoPoint, weight: number): Observable<DeliverySlot[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.deliveryCalculator, {
      queryParams: { ...geoPoint, weight },
    });

    const isDnd = (date: string): 0 | 1 => {
      const now = new Date();
      const currentDate = new Date(date);

      return now.getDate() === currentDate.getDate() ? 0 : 1;
    };

    return this.http
      .get<OccDeliveryResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.deliveryCalculator),
      })
      .pipe(map(({ slots }) => slots?.map((slot) => ({ ...slot, date: new Date(slot.date), dnd: isDnd(slot.date) }))));
  }
}
